import styled from 'styled-components';

export const CreateUserPageContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding-bottom: 24px;
  box-sizing: border-box;
`;

export const FieldWrapper = styled.div`
  flex: 1;
  padding: 8px 0px;
`;

export const CheckboxWrapper = styled.div`
  flex: 1;
  padding: 8px 0px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const FieldSection = styled.div`
  padding: 16px;
  margin: 8px;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  background-color: white;
  box-sizing: border-box;
  box-shadow: 0px 2px 6px 2px rgba(0, 0, 0, 0.08),
    0px 1px 2px 0px rgba(0, 0, 0, 0.16);
`;

export const ResponsiveFieldSection = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 16px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 2px 6px 2px rgba(0, 0, 0, 0.08),
    0px 1px 2px 0px rgba(0, 0, 0, 0.16);
  flex-basis: calc(50% - 16px);
  min-width: 500px;

  @media screen and (max-width: 1100px) {
    flex-basis: 100%;
    width: 100%;
    min-width: unset;
  }
`;
